import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default function getEnvelopeBody(method) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var mappedHeaders = Object.entries(headers).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (acc[key]) {
      acc[key].push(val);
    } else {
      acc[key] = [val];
    }

    return acc;
  }, {}); // As per the Json type, `data` could be null. We don't want to send 'null' as the value of body
  // JSON.stringify will preserve that, whereas with 'undefined` the field is dropped during
  // serialization

  if (data) {
    return JSON.stringify({
      method: method,
      headers: mappedHeaders,
      body: data
    });
  }

  return JSON.stringify({
    method: method,
    headers: mappedHeaders
  });
}
//# sourceMappingURL=getEnvelopeBody.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/web-sdk/dist/esm/net/getEnvelopeBody.js
// module id = 226
// module chunks = 0 1